import * as React from 'react'

import { createFiltersContext } from 'modules/core/components/DataTable/contexts/FiltersContext'

export default function useFilters<T>() {
  const Context = createFiltersContext<T>()
  const value = React.useContext(Context)

  if (!value) {
    throw new Error('useFilters must be used within a FiltersProvider')
  }

  return value
}
